//JS file

import { initBackToTop } from '../storybook/js/back-to-top.js';
import "./components/navigation";
import "./components/search-form";
import "./components/swiper";

document.addEventListener('DOMContentLoaded', () => {
    initBackToTop();
});